import React from 'react';
import './NoAccessWidget.scss';
import { ReactComponent as InfoCircleBlueIcon } from '../../images/info-circle-blue.svg';

interface NoAccessComponentProps {
    message?: string;
    useInfoIcon?: boolean;
}

/**
 * NoAccessComponent - A simplified version of NoAccessWidget without the header.
 * This component is designed to be used within existing widgets when access is denied.
 * 
 * @param {string} message - The message to display (defaults to "You do not have access to this widget.")
 * @param {boolean} useInfoIcon - Whether to use the info icon (blue circle) instead of the default empty state icon
 */
const NoAccessComponent: React.FC<NoAccessComponentProps> = ({
    message = 'You do not have access to this widget.',
}) => {
    return (
        <section className='no-access-state'>
            <div className='no-access-state__info-icon'>
                <div className='no-access-state__info-icon-outer'>
                    <div className='no-access-state__info-icon-outer-inner'>
                        <InfoCircleBlueIcon />
                    </div>
                </div>
            </div>
            <p className='no-access-state__message'>
                {message}
            </p>
        </section>
    );
};

export default React.memo(NoAccessComponent);